import { trigger, transition, animateChild, query } from '@angular/animations';
import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { ToastService, AppNotification } from '@icc/shared/helpers/b2b';

@Component({
    selector: 'icc-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    animations: [
        trigger('toastAnimation', [transition(':enter, :leave', [query('@*', animateChild())])]),
    ],
})
export class ToastComponent implements OnInit, OnDestroy {
    messages: AppNotification[];

    @Input() showTransformOptions = 'translateY(100%)';

    @Input() hideTransformOptions = 'translateY(-100%)';

    @Input() showTransitionOptions = '300ms ease-out';

    @Input() hideTransitionOptions = '250ms ease-in';

    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() onClose: EventEmitter<{
        message: AppNotification;
    }> = new EventEmitter();

    messageSubscription: Subscription;
    clearSubscription: Subscription;

    constructor(public toastService: ToastService, private cd: ChangeDetectorRef) {}

    ngOnInit(): void {
        this.messageSubscription = this.toastService.messageObserver.subscribe((messages) => {
            if (messages) {
                if (messages instanceof Array) {
                    const filteredMessages = messages;
                    this.add(filteredMessages);
                } else {
                    this.add([messages]);
                }
            }
        });

        this.clearSubscription = this.toastService.clearObserver.subscribe((key: string | null) => {
            if (!key) {
                this.messages = null;
            } else {
                this.messages = this.messages?.filter(msg => msg.key !== key);
            }

            this.cd.markForCheck();
        });
    }

    ngOnDestroy() {
        if (this.messageSubscription) {
            this.messageSubscription.unsubscribe();
        }

        if (this.clearSubscription) {
            this.clearSubscription.unsubscribe();
        }
    }

    add(messages: AppNotification[]): void {
        this.messages = this.messages ? [...this.messages, ...messages] : [...messages];

        this.cd.markForCheck();
    }

    onMessageClose(event: {
        index: number;
        message: AppNotification
    }) {
        this.messages.splice(event.index, 1);

        this.onClose.emit({
            message: event.message,
        });

        this.cd.detectChanges();
    }
}
